import { createFileRoute, notFound } from '@tanstack/react-router'
import { DeviceNotFound } from '../../components/errors/NotFound.tsx'
import { deviceListQuery } from '../../data/devices.ts'
import { DeviceDetails } from '../../features/devices/DeviceDetails.tsx'

export const Route = createFileRoute('/_app/devices/$id')({
	component: DeviceDetails,
	notFoundComponent: () => <DeviceNotFound redirectTo='/devices' />,
	loader: async ({ context: { queryClient, impersonation }, params }) => {
		const devices = await queryClient.ensureQueryData(deviceListQuery(impersonation?.partyAccountId))
		if (!devices.some((device) => device.id === params.id)) {
			throw notFound()
		}
	},
})
